import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = "sm", onChange = null, testid = "stars" }) {
  const sizes = { sm: "w-3.5 h-3.5", md: "w-5 h-5", lg: "w-6 h-6" };
  const cls = sizes[size] || sizes.sm;
  return (
    <div className="inline-flex items-center gap-0.5" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = i <= Math.round(value);
        const Comp = onChange ? "button" : "span";
        return (
          <Comp
            key={i}
            type={onChange ? "button" : undefined}
            onClick={onChange ? () => onChange(i) : undefined}
            data-testid={`${testid}-${i}`}
            className={onChange ? "cursor-pointer" : ""}
          >
            <Star className={`${cls} ${filled ? "fill-amber-400 text-amber-400" : "text-muted-foreground/30"}`} />
          </Comp>
        );
      })}
    </div>
  );
}
